module.exports = __webpack_public_path__ + "img/logo.full.f8a5b844.png";